import { useToast } from "@ecco/ui/use-toast";
import { Warning } from "../components/ui/warning";
import { useGetHeaders } from "@hooks/useGetHeaders";
import { TryAndBuy } from "@lib/constants/contentful/try-and-buy";

type Props = {
    onOpen: () => void;
};

export const useWarning = ({ onOpen }: Props) => {
    const { toast } = useToast();
    const headers = useGetHeaders({
        microcopiesWithTitles: {
            title: TryAndBuy.warning.title,
            description: TryAndBuy.warning.description,
            confirm: TryAndBuy.warning.confirm,
            close: TryAndBuy.warning.close,
        },
    });

    const onConfirm = () => {
        toast.closeAll();
        onOpen();
    };

    const onClose = () => toast.closeAll();

    const showWarning = () => {
        toast({
            position: "top",
            duration: null,
            render: () => <Warning onConfirm={onConfirm} onClose={onClose} headers={headers} />,
        });
    };

    return {
        showWarning,
    };
};
